import React, {RefObject} from 'react';
import {JAVASCRIPT_VOID} from 'constants/config';
import Dim from 'components/common/Dim';
import {t} from 'lib/i18n';

/**
 * 영상 저장 모달 컴포넌트
 */

interface ISaveProps {
  marginState: string;
  popupWrapRef: RefObject<HTMLDivElement>;
  onClickSaveCancel: () => void;
  onClickSave: () => void;
}

const Save = ({
  marginState,
  popupWrapRef,
  onClickSaveCancel,
  onClickSave,
}: ISaveProps) => {
  return (
    <>
      <Dim onClick={onClickSaveCancel} />
      <div
        className='popup_wrap'
        id='popupWrap'
        ref={popupWrapRef}
        style={{
          maxWidth: '600px',
          margin: marginState,
        }}>
        <div className='popup_contents'>
          <div className='text_confirm'>
            <strong>{t('편집된 영상을 저장하시겠습니까?')}</strong>
            <p>
              {t(
                '영상을 저장하는데 오랜 시간이 소요될 수 있습니다.\n 영상 처리중에 기존 영상은 재생이 가능하지만,\n 처리중인 영상을 편집 할 수 없습니다.',
              )
                .split('\n')
                .map((line: string, index: number) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </p>
          </div>
        </div>
        <div className='btn_wrap'>
          <button type='button' className='btn1' onClick={onClickSaveCancel}>
            {t('취소')}
          </button>
          <button type='button' className='btn2' onClick={onClickSave}>
            {t('저장')}
          </button>
        </div>
        <a
          href={JAVASCRIPT_VOID}
          className='popup_close'
          onClick={onClickSaveCancel}>
          popup close
        </a>
      </div>
    </>
  );
};

export default Save;
